(() => {
  const clean = (value) => value.replace(/\s+/g, ' ').trim();

  const parseVariant = (label) => {
    const parts = clean(label).split('·').map(clean);
    if (parts.length < 2) return null;
    const quantityText = parts.slice(1).join(' · ');
    const isThree = /(^|\s)3\s*vials?/i.test(quantityText);
    const isSingle = /(^|\s)1\s*vial/i.test(quantityText);
    if (!isThree && !isSingle) return null;
    return {
      strength: parts[0],
      quantity: isThree ? '3 vials' : 'Single vial',
      quantityKey: isThree ? 'three' : 'single',
      optionLabel: clean(label)
    };
  };

  const unique = (items) => [...new Set(items)];

  function enhance(select) {
    if (select.dataset.iflEnhanced === 'true') return;
    const options = [...select.options].map((option) => ({
      option,
      parsed: parseVariant(option.textContent || option.label || '')
    }));
    if (!options.length || options.some((entry) => !entry.parsed)) return;
    const isWater = /\/products\/bac-water(?:\/|$)/.test(location.pathname);
    if (isWater) {
      const single = options.find((entry) => entry.parsed.quantityKey === 'single');
      if (single) select.value = single.option.value;
    }

    select.dataset.iflEnhanced = 'true';
    const nativeField = select.closest('.product-form__input');
    if (!nativeField) return;
    nativeField.classList.add('ifl-native-variant-hidden');

    const picker = document.createElement('div');
    picker.className = 'ifl-variant-picker';
    picker.innerHTML = `
      <fieldset class="ifl-variant-group" data-group="strength">
        <legend>Choose Vial Content</legend><small class="ifl-vial-content-note">MG indicates the total content contained in each vial.</small>
        <div class="ifl-variant-options"></div>
      </fieldset>
      <fieldset class="ifl-variant-group" data-group="quantity">
        <legend>Choose Vial Quantity</legend>
        <div class="ifl-variant-options"></div>
        <p class="ifl-bundle-note">Compare the selected three-vial price above.</p>
      </fieldset>`;
    nativeField.before(picker);
    if (isWater) picker.querySelector('.ifl-bundle-note').hidden = true;

    const selectedEntry = () => options.find((entry) => entry.option.selected) || options[0];
    let strength = selectedEntry().parsed.strength;
    let quantityKey = selectedEntry().parsed.quantityKey;
    const strengths = unique(options.map((entry) => entry.parsed.strength));
    const quantities = (isWater ? ['single'] : ['single', 'three']).filter((key) => options.some((entry) => entry.parsed.quantityKey === key));

    const makeButton = (group, value, label, extra = '') => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `ifl-variant-button ${extra}`.trim();
      button.dataset.group = group;
      button.dataset.value = value;
      button.textContent = label;
      button.addEventListener('click', () => {
        if (button.disabled) return;
        if (group === 'strength') strength = value;
        else quantityKey = value;
        const match = options.find((entry) => entry.parsed.strength === strength && entry.parsed.quantityKey === quantityKey);
        if (!match) return;
        select.value = match.option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      return button;
    };

    const strengthWrap = picker.querySelector('[data-group="strength"] .ifl-variant-options');
    strengths.forEach((value) => strengthWrap.append(makeButton('strength', value, value.toUpperCase())));
    const quantityWrap = picker.querySelector('[data-group="quantity"] .ifl-variant-options');
    quantities.forEach((value) => quantityWrap.append(makeButton('quantity', value, value === 'three' ? '3 vials' : 'Single vial', value === 'three' ? 'ifl-variant-button--bundle' : '')));

    function sync() {
      const current = selectedEntry();
      strength = current.parsed.strength;
      quantityKey = current.parsed.quantityKey;
      picker.querySelectorAll('.ifl-variant-button').forEach((button) => {
        const active = button.dataset.group === 'strength' ? button.dataset.value === strength : button.dataset.value === quantityKey;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        if (button.dataset.group === 'quantity') {
          const match = options.find((entry) => entry.parsed.strength === strength && entry.parsed.quantityKey === button.dataset.value);
          button.disabled = !match || match.option.disabled;
        }
      });
    }

    select.addEventListener('change', sync);
    sync();
  }

  function enhanceSplit(container) {
  if (container.dataset.iflSplitEnhanced === 'true' || container.querySelector('.ifl-variant-picker')) return;
  const selects = [...container.querySelectorAll('select')];
  if (selects.length < 2) return;
  const strengthSelect = selects.find((select) => /content|strength|mg/i.test(select.name || select.getAttribute('aria-label') || '') || [...select.options].every((option) => /\b\d+(?:\.\d+)?\s*mg\b/i.test(clean(option.textContent || option.label || ''))));
  const quantitySelect = selects.find((select) => /quantity|vial/i.test(select.name || select.getAttribute('aria-label') || '') || [...select.options].every((option) => /vials?/i.test(clean(option.textContent || option.label || ''))));
  if (!strengthSelect || !quantitySelect || strengthSelect === quantitySelect) return;
  container.dataset.iflSplitEnhanced = 'true';
  [strengthSelect, quantitySelect].forEach((select) => {
    select.dataset.iflEnhanced = 'true';
    select.closest('.product-form__input')?.classList.add('ifl-native-variant-hidden');
  });
  const picker = document.createElement('div');
  picker.className = 'ifl-variant-picker';
  picker.innerHTML = '<fieldset class="ifl-variant-group" data-group="strength"><legend>Choose Vial Content</legend><p class="ifl-strength-note">MG indicates the total content contained in each vial.</p><div class="ifl-variant-options"></div></fieldset><fieldset class="ifl-variant-group" data-group="quantity"><legend>Choose Vial Quantity</legend><div class="ifl-variant-options"></div><p class="ifl-bundle-note">Compare the selected three-vial price above.</p></fieldset>';
  strengthSelect.closest('.product-form__input').before(picker);
  const addButtons = (select, group, wrap) => {
    [...select.options].forEach((option) => {
      const button = document.createElement('button');
      const label = clean(option.textContent || option.label || option.value).replace(/\s*-\s*Unavailable$/i, '');
      const isThree = /(^|\s)3\s*vials?/i.test(label);
      button.type = 'button';
      button.className = ('ifl-variant-button ' + (isThree ? 'ifl-variant-button--bundle' : '')).trim();
      button.textContent = group === 'strength' ? label.toUpperCase() : (isThree ? '3 vials' : 'Single vial');
      button.disabled = option.disabled;
      button.addEventListener('click', () => {
        if (button.disabled) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      wrap.append(button);
    });
  };
  const strengthWrap = picker.querySelector('[data-group="strength"] .ifl-variant-options');
  const quantityWrap = picker.querySelector('[data-group="quantity"] .ifl-variant-options');
  addButtons(strengthSelect, 'strength', strengthWrap);
  addButtons(quantitySelect, 'quantity', quantityWrap);
  function sync() {
    [...strengthWrap.children].forEach((button, index) => {
      const active = strengthSelect.options[index]?.selected;
      button.classList.toggle('is-selected', Boolean(active));
      button.setAttribute('aria-pressed', String(Boolean(active)));
    });
    [...quantityWrap.children].forEach((button, index) => {
      const active = quantitySelect.options[index]?.selected;
      button.classList.toggle('is-selected', Boolean(active));
      button.setAttribute('aria-pressed', String(Boolean(active)));
    });
  }
  strengthSelect.addEventListener('change', sync);
  quantitySelect.addEventListener('change', sync);
  sync();
}

function init() {
    document.querySelectorAll('variant-selects, variant-radios').forEach((container) => {
      container.querySelectorAll('select').forEach(enhance);
      enhanceSplit(container);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      init();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  init();
})();
